import FolderClient from './FolderClient';
import HttpClient from '../../gateway/HttpClient';
import ComponentName from 'constant/ComponentName';
import { ComponentCategory } from '../../domain/category/CategoryOperationDomains';
import { notBlank, notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { ComponentCategoryMethods } from '../../constant/MethodNames';

class NestFolderClient implements FolderClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public async addItemToCategory(component: ComponentName, categoryId: string, itemId: string): Promise<void> {
    notUndefined(component, 'Component cannot be undefined');
    notBlank(component, 'Component cannot be blank');
    notUndefined(categoryId, 'Category id cannot be undefined');
    notBlank(categoryId, 'Category id cannot be blank');
    notUndefined(itemId, 'Item id cannot be undefined');
    notBlank(itemId, 'Item id cannot be blank');
    const dto = { component, categoryId, itemId };
    return this.httpClient.execute(HttpMethod.POST, `${ComponentCategoryMethods.ADD_ITEM_TO_CATEGORY}`, dto);
  }

  public async addCategoryToCategory(component: ComponentName, categoryId: string, category: ComponentCategory): Promise<void> {
    notUndefined(component, 'Component cannot be undefined');
    notBlank(component, 'Component cannot be blank');
    notUndefined(categoryId, 'Category id cannot be undefined');
    notBlank(categoryId, 'Category id cannot be blank');
    notUndefined(category, 'category cannot be undefined');
    const dto = { component, object: category };
    return this.httpClient.execute(HttpMethod.POST, `${ComponentCategoryMethods.ADD_CATEGORY_TO_CATEGORY}/${categoryId}`, dto);
  }

  public add(component: ComponentName, object: ComponentCategory, parentFolderId: string): Promise<void> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    notUndefined(object, 'Component category cannot be undefined');
    notUndefined(parentFolderId, 'Parent folder id cannot be undefined');
    notBlank(parentFolderId, 'Parent folder id cannot be blank');
    const dto = { component, object };
    return this.httpClient.execute(HttpMethod.POST, `${ComponentCategoryMethods.ADD}/${parentFolderId}`, dto);
  }

  public delete(component: ComponentName, id: string): Promise<void> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    const dto = { component, id };
    return this.httpClient.execute(HttpMethod.DELETE, ComponentCategoryMethods.DELETE, dto);
  }

  public updateName(component: ComponentName, id: string, name: string): Promise<void> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    const dto = { component, id, name };
    return this.httpClient.execute(HttpMethod.PUT, ComponentCategoryMethods.UPDATE_NAME, dto);
  }

  public fix(component: ComponentName): Promise<void> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ComponentCategoryMethods.CALCULATE_NON_CATEGORY}/${component}`);
  }

  public findMany(component: ComponentName): Promise<ComponentCategory[]> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, ComponentCategoryMethods.FIND_MANY, undefined, { component });
  }

  public getComponentCountsWithAccess(component: ComponentName, categoryId: string): Promise<number> {
    notUndefined(component, 'Component name cannot be undefined');
    notBlank(component, 'Component name cannot be blank');
    notUndefined(categoryId, 'Category id cannot be undefined');
    notBlank(categoryId, 'Category id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${ComponentCategoryMethods.GET_COMPONENT_COUNT_WITH_ACCESS}/${component}/${categoryId}`);
  }
}

export default NestFolderClient;
